import React, {useEffect, useState} from 'react';
import frontendUtils from '../../../utils/frontendUtils';
import {Trans} from 'react-i18next';
import smbUtils from '../../../utils/smbUtils';
import i18n from 'i18next';
import langUtils from '../../../utils/langUtils';

export default function Footer() {
  const [scrollTopVisible, setScrollTopVisible] = useState(false);

  const handleScroll = () => setScrollTopVisible(window.scrollY > 100);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function scrollToTop() {
    const duration = 350;
    const step = -window.scrollY / (duration / 15),
      scrollInterval = setInterval(() => {
        if (window.scrollY !== 0) {
          window.scrollBy(0, step);
        } else {
          clearInterval(scrollInterval);
        }
      }, 15);
  }

  return (
    <div className="kt-footer kt-grid__item">
      <div className="kt-container">
        <div className="kt-footer__wrapper">
          <div className="kt-footer__copyright">
            {1900 + new Date().getYear()}&nbsp;&copy;&nbsp;
            <a
              href={
                smbUtils.getUrl() +
                langUtils.convertToFrontendLangUrl(i18n.language)
              }
              target="_blank"
              rel="noopener noreferrer"
              className="kt-link"
            >
              Management Console by Perfect Corp.
            </a>
          </div>
          <div className="kt-footer__menu">
            <a
              href={frontendUtils.getAboutUsUrl('home')}
              target="_blank"
              rel="noopener noreferrer"
              className="kt-link"
              m="1"
            >
              <Trans i18nKey="c.l.footer.about">About</Trans>
            </a>
            <a
              href={frontendUtils.getContactUsUrl('home')}
              target="_blank"
              rel="noopener noreferrer"
              className="kt-link"
              m="1"
            >
              <Trans i18nKey="c.l.footer.contact">Contact</Trans>
            </a>
          </div>
          {scrollTopVisible && (
            <a
              href="javascript:;"
              className="scroll-to-top"
              style={{display: 'block'}}
              onClick={() => scrollToTop()}
            >
              <i className="fa fa-arrow-circle-up" />
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
